import type { MouseEvent, ReactNode } from "react";

/**
 * 콘솔 내부 링크.
 *
 * 진짜 `<a href>` 로 두는 것이 중요합니다 — 주소가 보이고, 가운데 클릭/새 탭이 동작하고,
 * 스크린리더가 링크로 읽습니다. 클릭만 가로채 history API 로 처리합니다.
 *
 * 수정키(⌘/Ctrl/Shift)·보조 버튼 클릭은 **브라우저에 맡깁니다** — 가로채면 "새 탭으로 열기" 가
 * 같은 탭 이동이 되어 버립니다.
 */
export function AppLink({
  href,
  className,
  ariaCurrent,
  onNavigate,
  children,
}: {
  href: string;
  className?: string;
  ariaCurrent?: boolean;
  onNavigate: (href: string) => void;
  children: ReactNode;
}) {
  const onClick = (ev: MouseEvent<HTMLAnchorElement>) => {
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;
    ev.preventDefault();
    onNavigate(href);
  };

  return (
    <a
      href={href}
      className={className}
      aria-current={ariaCurrent ? "page" : undefined}
      onClick={onClick}
    >
      {children}
    </a>
  );
}
